import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-hulpmiddelen-gezin',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconHulpmiddelenGezin {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M26.91 3.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5S32.34 7 30.41 7s-3.5-1.57-3.5-3.5M20.41 7c1.93 0 3.5-1.57 3.5-3.5S22.34 0 20.41 0s-3.5 1.57-3.5 3.5S18.48 7 20.41 7M14.9 21.15V11c-.01-1.66 1.33-2 2.99-2h4.45c1.66 0 3 1.34 3 3 0-1.66 1.34-3 3-3h4.57c1.66 0 3 1.34 3 3v11h-2v5c-.82-.25-1.79-.41-2.94-.41h-.28l-.78.08v-5.61c0-1.14-.92-2.06-2.06-2.06h-4.98c-1.1 0-1.99.89-1.99 1.99v.89l-5.17-1.56-.65-.2-.16.02ZM22.41 16c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3m-7.57 8.19L9 25.07v8l11.96 3 14.1-3.08s0-2.4-4.1-2.4l-10 .93-4.76-1.21.78-2.24 3.94 1.01h3.18s-.22-2.22-3.1-3.03zM6 24.08H0v10h6z"/>
</svg>

    );
  }
}
